/* eslint-disable import/prefer-default-export */
import { Auth } from 'aws-amplify';

export async function getJwtToken(): Promise<string> {
  const session = await Auth.currentSession();
  const idToken = session.getIdToken();
  return idToken.getJwtToken();
}
